import { getStoredUser } from './authSession';

export const AUTHENTICATED_USER_MISMATCH_DETAIL =
  'Authenticated user does not match requested user';

export const normalizeRequestedUserEmail = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  if (!normalized || normalized === 'undefined' || normalized === 'null') {
    return null;
  }

  return normalized;
};

export const createAuthenticatedUserMismatchError = ({
  requestedEmail,
  resourceLabel = 'resource',
} = {}) => {
  const error = new Error(AUTHENTICATED_USER_MISMATCH_DETAIL);
  error.code = 'AUTHENTICATED_USER_MISMATCH';
  error.status = 403;
  error.detail = AUTHENTICATED_USER_MISMATCH_DETAIL;
  error.requestedEmail = normalizeRequestedUserEmail(requestedEmail);
  error.currentEmail = getStoredUser()?.email || null;
  error.resourceLabel = resourceLabel;
  return error;
};

export const isAuthenticatedUserMismatchError = (error) =>
  error?.code === 'AUTHENTICATED_USER_MISMATCH' ||
  (error?.status === 403 &&
    error?.detail === AUTHENTICATED_USER_MISMATCH_DETAIL) ||
  error?.message === AUTHENTICATED_USER_MISMATCH_DETAIL;

export const buildAuthenticatedUserMismatchMessage = ({
  currentEmail,
  requestedEmail,
  resourceLabel = 'resource',
} = {}) => {
  const currentAccount = currentEmail || 'an unknown account';

  if (requestedEmail) {
    return `You are currently signed in as ${currentAccount}, but this ${resourceLabel} was requested for ${requestedEmail}.`;
  }

  return `You are currently signed in as ${currentAccount}, but this ${resourceLabel} is not available for the authenticated account.`;
};
